import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

import Button from '../../../../../../../react-components/Button';
import { Dropdown } from '../../../../../../../react-components/Dropdown';
import { Text } from '../../../../../../../react-components/Text';
import { StopReportContainer } from './StopReportContainer';

interface StopCancelProps {
  options: string[]; //TODO si se quieren poner iconos
  titleIntId?: string;
  title?: string;
  arrayMultiSelect: number[];
  setArrayMultiSelect: (array: number[]) => void;
  headerStyle?: React.CSSProperties;
  buttonStyle?: React.CSSProperties;
  textStyle?: React.CSSProperties;
  multipleChoice?: boolean;
  showMandatory?: boolean;
  isMandatory?: boolean;
  headerImage?: React.ReactNode;
  isCustomField?: boolean;
}

export const MultipleChoiceForm = ({
  options,
  titleIntId,
  title,
  arrayMultiSelect,
  setArrayMultiSelect,
  headerStyle,
  buttonStyle,
  textStyle,
  multipleChoice,
  showMandatory,
  isMandatory,
  headerImage,
  isCustomField,
}: StopCancelProps) => {
  if (!options) return null;

  const renderContent = (): React.ReactNode => {
    return (
      <Grid item style={{ transition: `height 0.3s ease` }}>
        {options.map((button, index) => (
          <Button
            key={index}
            onClick={() => {
              // In case the categorical is not multiple choice
              if (!multipleChoice) {
                // If it have the value
                if (arrayMultiSelect.includes(index)) setArrayMultiSelect([]);
                // If it don't have the value
                else setArrayMultiSelect([index]);
              }
              // In case it's multiple choice and the value it's already in it
              else if (arrayMultiSelect.includes(index) && multipleChoice) {
                setArrayMultiSelect(arrayMultiSelect.filter((item) => item !== index));
              }
              // In case it's multiple choice and the value it's not in it
              else {
                setArrayMultiSelect([...arrayMultiSelect, index]);
              }
            }}
            style={{
              height: `30px`,
              fontSize: `18px`,
              marginBottom: `10px`,
              border: arrayMultiSelect.includes(index)
                ? `1px solid ${RoutalPalette.primary40}`
                : `1px solid ${RoutalPalette.grey7}`,
              fontWeight: `normal`,
              color: arrayMultiSelect.includes(index) ? RoutalPalette.white : `${RoutalPalette.secondary00}`,
              backgroundColor: arrayMultiSelect.includes(index) ? RoutalPalette.primary40 : `transparent`,
              ...buttonStyle,
              borderRadius: `10px`,
            }}
            intlId={isCustomField ? undefined : button}
          >
            <Text
              style={{
                fontSize: `13px`,
                marginLeft: `2px`,
                color: arrayMultiSelect.includes(index) ? RoutalPalette.white : `${RoutalPalette.secondary00}`,
              }}
              variant="label"
            >
              {isCustomField ? button : undefined}
            </Text>
          </Button>
        ))}
      </Grid>
    );
  };

  return (
    <>
      {multipleChoice && options.length >= 5 ? (
        // TODO: Implement version for multiple choice with mandatory_field (v3 of drivers)
        <Dropdown titleIntId={titleIntId} title={title} imageHeader={headerImage}>
          {renderContent()}
        </Dropdown>
      ) : (
        <StopReportContainer
          textId={titleIntId}
          text={title}
          childrenImage={headerImage}
          showMandatory={showMandatory}
          hasValue={arrayMultiSelect.length > 0}
          isMandatory={isMandatory}
        >
          {renderContent()}
        </StopReportContainer>
      )}
    </>
  );
};
